module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [(_vm.state == 'settings' || _vm.state == 'journey') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.state = 'settings'
      }
    }
  }, [_vm._v("Questions")]) : _vm._e(), _vm._v(" "), (_vm.state == 'settings' || _vm.state == 'journey') ? _c('span', [_vm._v(" | ")]) : _vm._e(), _vm._v(" "), (_vm.state == 'settings' || _vm.state == 'journey') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.state = 'journey'
      }
    }
  }, [_vm._v("Dashboard")]) : _vm._e()]), _vm._v(" "), (_vm.state == 'settings') ? _c('settings-screen', {
    on: {
      "start": function($event) {
        _vm.start($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 'journey') ? _c('journey-screen', {
    on: {
      "start": function($event) {
        _vm.start($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.state == 'quiz') ? _c('quiz-screen', {
    attrs: {
      "questions": _vm.questions,
      "paid": _vm.paid,
      "start": _vm.dateStart
    },
    on: {
      "back": function($event) {
        _vm.setState($event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21af6624"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 43
// module chunks = 0